<template>
<formulario 
  v-if="showNew"
  :key="keyForm"
  v-model="showNew"
  :tableName="sTableName"
  @saveOK="registroExitoso"
  :modNuevo="bNuevo"
  :oItem="(oData) ? oData : {}"
  :oDetalle="oDetalleFormulario"
  :sDetalleTitulo="sDetalleTitulo"
  :idItem="sIdTable"
  :titulo="titulo"
  :sCampoFiltro="sCampoFiltro"
  :oDataFormularioAdicional="oDataFormularioAdicional"
  :bDataFormularioAdicionalObligatorio="bDataFormularioAdicionalObligatorio"
  :nIdValor="nIdValor"
  :bCamposModoEditar = "bCamposFormModoEditar"
  @onCerrar="onCancelar()"
  >
</formulario>
</template>
<script>
import mxFunciones from "@/mixins/funciones.js";
import formulario from '@/components/Form/Form.vue'

export default {
  name: "FormIndicador",
  components: {
    formulario,
  },
  mixins: [mxFunciones],
  props: {
    oData: {
      type: Object,
      default: () => {},
    },
    bMostrarFormulario: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    bNuevo: {
      type: Boolean,
      default: true, 
    },
    sTableName: {
      type: String,
      default: '',
    },
    sIdTable:{
      type: String,
      default: '',
    },
    titulo: {   
      type: String,
      default: ''
    },
    sCampoFiltro:{
      type: String,
      default: '',
    },
    nIdValor: {
      type: Number,
      default: 0
    },
    bCamposFormModoEditar:{ //Prop para decidir si los campos solo se basaran en las condiciones del modo editar
      type:Boolean,
      default:false
    },
    oDataFormularioAdicional: {
      type: Object,
       default: () => {}
    },
    bDataFormularioAdicionalObligatorio: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      keyForm : 0,
      showNew : false,
      oDetalleFormulario : {},
      sDetalleTitulo : '',
    }
  },
  async mounted() {
    this.onIniciarVista();
  },
  methods: {
    onIniciarVista() {
      this.keyForm += 1 
      this.showNew = this.bMostrarFormulario
      this.oDetalleFormulario = {}
      this.sDetalleTitulo = ''
    },
    onCancelar() {
      this.$emit('onCancelar')
    },
    registroExitoso(oRegistro) {
      this.$emit('onRegistroExitoso', oRegistro)
    },

  },
};
</script>
<style lang="scss" scoped>

</style>
